var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_2653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5264 17.106L14.9282 12.5076C15.7095 11.2638 16.1629 9.79372 16.1629 8.21606C16.1629 3.75262 12.5446 0.134766 8.08129 0.134766C3.61803 0.134766 0 3.75262 0 8.21606C0 12.6797 3.61786 16.2972 8.08129 16.2972C9.7982 16.2972 11.3885 15.7604 12.6971 14.8483L17.2405 19.3921C17.5562 19.7074 17.9701 19.8645 18.3834 19.8645C18.7973 19.8645 19.2107 19.7074 19.5269 19.3921C20.1578 18.7605 20.1578 17.7375 19.5264 17.106ZM8.08129 13.679C5.06453 13.679 2.61873 11.2333 2.61873 8.21639C2.61873 5.19946 5.06453 2.75366 8.08129 2.75366C11.0982 2.75366 13.5439 5.19946 13.5439 8.21639C13.5439 11.2333 11.0982 13.679 8.08129 13.679Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_2653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.1190297e68afcbd3164bb86d12be5f02.svg";
export { ForwardRef as ReactComponent };